import { useState } from "react";
import { Play } from "lucide-react";

export const LiteVideo = ({ id, title, testId }) => {
  const [on, setOn] = useState(false);
  return (
    <div
      data-testid={testId}
      className="relative aspect-video w-full overflow-hidden rounded-[22px] bg-black shadow-[0_40px_90px_-40px_rgba(0,0,0,0.75)] ring-1 ring-white/10"
    >
      {on ? (
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          onClick={() => setOn(true)}
          data-testid={`${testId}-play`}
          className="group absolute inset-0 h-full w-full"
          aria-label={`Reproduzir vídeo: ${title}`}
        >
          <img src={`/assets/yt-${id}.jpg`} alt={title} className="h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-[1.03]" />
          <span className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-black/10" />
          <span className="absolute left-1/2 top-1/2 grid h-20 w-20 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white/15 backdrop-blur-md ring-1 ring-white/40 transition-[transform,background-color] duration-500 group-hover:scale-105 group-hover:bg-white/25">
            <span className="absolute inset-0 animate-[breathe_3.2s_ease-in-out_infinite] rounded-full ring-1 ring-white/30" />
            <Play className="ml-1 text-white" size={26} fill="white" />
          </span>
        </button>
      )}
    </div>
  );
};
